import { render, staticRenderFns } from "./GeneralSystemPreferences.vue?vue&type=template&id=77472d11&scoped=true"
import script from "./GeneralSystemPreferences.vue?vue&type=script&lang=js"
export * from "./GeneralSystemPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77472d11",
  null
  
)

export default component.exports